module.exports = __webpack_public_path__ + "static/media/michaelMachado.1d97c3b7.png";